module.exports = __webpack_public_path__ + "img/CN.079e8e99.webp";